<template>
  <div class="ps" :style="vars">
    <main :class="['ps-main', { narrow, wide }]">
      <slot />
    </main>
    <footer v-if="$slots.footer" class="ps-foot"><slot name="footer" /></footer>
  </div>
</template>

<script>
import { brandVars } from '../lib/color';

// The frame of every signed-out page: TrustClap's paper and ink, with the brand colour on top.
export default {
  name: 'PublicShell',
  props: {
    color: { type: String, default: '#B4472B' },
    narrow: { type: Boolean, default: false },
    wide: { type: Boolean, default: false }
  },
  computed: { vars() { return brandVars(this.color || '#B4472B'); } }
};
</script>

<style scoped>
.ps{min-height:100vh;background:#FAF7F2;color:#1F2328;display:flex;flex-direction:column}
.ps-main{flex:1;width:100%;max-width:1080px;margin:0 auto;padding:48px 24px 56px;box-sizing:border-box}
.ps-main.narrow{max-width:640px}
.ps-main.wide{max-width:1240px}
.ps-foot{padding:20px 24px 32px;text-align:center;font-size:13px;color:#6B635B}
.ps-foot ::v-deep a{color:#4F4A45;text-underline-offset:3px;min-height:44px;display:inline-flex;align-items:center}
@media(max-width:600px){.ps-main{padding:24px 16px 40px}}
</style>
